<div class="scroll-top" @click.prevent="scrollTop" :class="{ 'is-active': isVisible }"><icon-chevron-up></icon-chevron-up></div>